<template>
  <div class="news-content-container">
    <back-open-chenter />
    <div class="news-content-panel">
      <div class="news-title">喜报！腾讯优图荣获维科杯·OFweek 2022人工智能行业社会责任贡献奖</div>
      <div class="news-date">2022年11月18日</div>
      <div class="news-content">
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news17/news17_17.gif"/>
          </div>
        </div>
        <p>
          11月16日，维科杯·OFweek 2022物联网与人工智能行业年度评选（OFweek China IoT＆AI Awards 2022）颁奖典礼成功举办，
          <span class="mark-text">腾讯优图实验室凭借在人工智能领域取得令人瞩目的成就，荣获“维科杯·OFweek 2022人工智能行业社会责任贡献奖”。</span>
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/newscenter/news26.jpeg"/>
          </div>
        </div>
        <p>维科杯·OFweek 2022物联网与人工智能行业年度评选是由高科技行业门户OFweek维科网主办，OFweek物联网、OFweek人工智能网承办，活动以其公正、客观的评选流程倍受业界广泛关注，已成为高科技领域最具专业性、影响力和代表性的行业评选之一。本次评选经过20余位来自人工智能各大协会、学会、科研机构、专家学者评审投票，通过三轮紧张刺激的评选，最终决出各项奖项。</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/news26_1.jpeg"/>
          </div>
        </div>
        <p>腾讯优图实验室作为腾讯旗下顶级的人工智能实验室，致力于计算机视觉领域的研究与落地，腾讯优图通过在技术创新、社会公益、可持续发展等多个领域的持续发力，不断探索技术如何助力社会发展与产业落地，积极拓展履行社会责任的领域和层次而获奖。</p>
        <p>
          目前，腾讯优图已拥有超过
          <span class="mark-text">1600件</span>
          全球AI专利，更有300余篇论文被AAAI、ICCV等国际顶级AI会议收录。凭借在视觉AI技术上的研究成果，优图实验室通过腾讯云共输出超过
          <span class="mark-text">20项</span>
          AI解决方案，
          <span class="mark-text">100+</span>
          AI原子能力，助力各行各业实现数字化转型。
        </p>
        <p>此外，腾讯优图还打造了如跨年龄AI寻人、未成年人内容审核、AI探星等技术能力，践行腾讯“科技向善”的使命和愿景。未来，优图实验室将继续专注人工智能技术发展，通过推进AI基础设施研发的形式为产业数字化转型提供助力，促进数字经济加速发展。通过实际行动，让科技有温度，让世界变得更美好。</p>
      </div>
    </div>
  </div>
</template>

<script>
import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
export default {
  name: 'News23',
  components: {
    BackOpenChenter
  }
};
</script>

<style lang="less" scoped>
@import "./news.less";
.news-content {
  margin: 0 auto;
  .image-panel {
    max-width: 667px;
    text-align: center;
    img {
      max-width: 667px;
    }
    span {
      font-size: 12px;
      color: #858585;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News26.vue